import React from "react"
import { CreateLeadFooter, StyledFlexEnd } from "./Styled"
import { Button, Stack } from "@mui/material";
import history from "../Utility/history";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { handleValidateCodevalue } from "../Utility/constant";

const BiztantuFooterButton = ({setIsViewMode, handlecreateNewmapping, handleActionButton2, headerLabel, actionlabel2 , sebtnLable="", isEdituser , isViewMode = false , getManagers , isiconRequired = false, backButtonLabel, handleCustomBackbutton, redirecturl, isBackbtnreq = true,  actionlabel, handleActionButton, isSecBtn= false}) => {

     const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
       
    const handlebackbutton = () => {
        if(redirecturl) {
            // getManagers();
            history.push(redirecturl)
        } else {
            handleCustomBackbutton()
        }
    }
    return (
        <>
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} width={"100%"} justifyContent={"space-between"} flexDirection={"row"}>
                   <Stack display={"flex"} alignItems={"center"} flexDirection={"row"}>
                    <Typography variant='h6'>
                            {handleValidateCodevalue(internationalise, headerLabel)}
                    </Typography>
                        
                    <Button className="edit-primary" style = {{ visibility: isBackbtnreq ? "" : "hidden", margin: "0px 25px 0px 25px" }} variant="outlined" onClick={handlebackbutton}>{backButtonLabel}</Button>
                    {(isViewMode && isEdituser) && 
                        <Button className="edit-primary" variant="outlined" onClick={()=>{setIsViewMode(false)}}>
                        {handleValidateCodevalue(internationalise,'COMMON_EDIT')}
                        </Button>}
                    {(actionlabel && !isViewMode ) && 
                        <Button className="edit-primary" variant="outlined" onClick={handleActionButton}>
                        {isiconRequired && <FileUploadIcon />}
                        {handleValidateCodevalue(internationalise,actionlabel)}
                    </Button>
                    }
                    {(isEdituser && !isViewMode ) && <Button className="edit-primary btn-space" variant="outlined" onClick={handleActionButton2}>
                        {handleValidateCodevalue(internationalise,actionlabel2)}
                    </Button>}
                    </Stack>
                    <Stack>
                        {isSecBtn && <Button className="secondry-edit-btn" variant='outlined' onClick={handlecreateNewmapping}>
                                {handleValidateCodevalue(internationalise, sebtnLable)}
                            </Button>
                        }
                    </Stack>
                </Stack>
            </CreateLeadFooter>
        </>
    )
}

export default BiztantuFooterButton;


